import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { searchDjTracks } from '../api/client.js';
import { djSearchQueryKey } from '../api/queryKeys.js';

import type { ChannelId, PartySlug, SearchResults } from '@mixwire/contracts';

// Expects an already-debounced term, and matches useSuggesterSearch's staleTime: a row's
// suggested count can change under the DJ while they are reading it.
export const useDjSearch = (
  slug: PartySlug,
  channelId: ChannelId,
  term: string,
): UseQueryResult<SearchResults> =>
  useQuery({
    queryKey: djSearchQueryKey(slug, channelId, term),
    queryFn: async () => searchDjTracks(slug, channelId, term),
    enabled: term !== '',
  });
